<template>
  <ion-modal :is-open="outletStore.showProductDetail" :initial-breakpoint="1" :breakpoints="[0, 0.65, 1]"
    @willDismiss="hideModal" class="product-detail-modal">
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-title>Detail Produk</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="hideModal" color="medium">Tutup</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding-horizontal">
      <div class="product-container">
        <div class="image-wrapper">
          <img
            :src="productDetails.image || 'https://res.cloudinary.com/dxcleuxwe/image/upload/v1758687442/placeholder/no-product-image_v7tdrr.png'"
            class="main-image" />
          <ion-button class="share-fab" @click="shareLoading">
            <ion-icon :icon="shareSocialOutline"></ion-icon>
          </ion-button>
        </div>

        <div class="info-section">
          <div class="price-badge">{{ formatter.format(productDetails.price) }}</div>
          <h2 class="product-title">{{ productDetails.name }}</h2>

          <div class="divider"></div>

          <label class="section-label">Deskripsi</label>
          <p class="product-description">
            {{ productDetails.description || 'Tidak ada deskripsi untuk produk ini.' }}
          </p>
        </div>
      </div>
    </ion-content>

    <ion-footer class="ion-no-border footer-action">
      <div class="button-group">
        <ion-button v-if="productDetails.status === 'available' && !checkProductAlready" expand="block" class="btn-main"
          @click="addToCartAction">
          Tambah ke Keranjang
        </ion-button>

        <ion-button v-else-if="productDetails.status !== 'available'" expand="block" fill="outline" color="danger"
          disabled>
          Stok Habis
        </ion-button>

        <ion-button v-else expand="block" fill="solid" color="medium" disabled>
          Sudah di Keranjang
        </ion-button>
      </div>
    </ion-footer>
  </ion-modal>
</template>

<script>
import {
  IonModal, IonHeader, IonToolbar, IonTitle, IonContent,
  IonButton, IonIcon, IonFooter, IonButtons,
  loadingController
} from '@ionic/vue';
import { shareSocialOutline } from 'ionicons/icons';
import { useOutletStore } from "@/stores/outlet";

export default {
  name: "ProductDetails",
  props: ["productDetails", "checkProductAlready"],
  components: {
    IonModal, IonHeader, IonToolbar, IonTitle, IonContent,
    IonButton, IonIcon, IonFooter, IonButtons
  },
  setup() {
    return { shareSocialOutline };
  },
  data() {
    return {
      formatter: new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }),
    };
  },
  computed: {
    outletStore() { return useOutletStore(); },
  },
  methods: {
    hideModal() {
      this.outletStore.setShowProductDetail(false);
    },
    async shareLoading() {
      const loading = await loadingController.create({
        message: 'Menyiapkan Link...',
        spinner: 'crescent'
      });
      await loading.present();

      await this.share();
      loading.dismiss();
    },
    async share() {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}`);

        const id = this.$route.params.id;
        const apiUrl = `${process.env.VUE_APP_BASE_URL}v1/product/url/${this.productDetails.id}?redirect=${process.env.VUE_APP_URL}${id}/${this.productDetails.id}`;

        const res = await fetch(apiUrl, { headers: myHeaders });
        if (res.ok) {
          const data = await res.json();
          this.$emit("generate-url", data.data.url);
        }
      } catch (error) {
        console.error("Share error:", error);
      }
    },
    addToCartAction() {
      const { name, price, id, detailId, image, tax } = this.productDetails;
      const permanentTax = tax ? tax.filter(t => t.tax_status === "permanent") : [];

      const product = {
        product_name: name,
        price,
        product_id: id,
        product_detail_id: detailId,
        qty: 1,
        photo: image,
        note: '',
        tax: permanentTax,
      };
      this.$emit("add-product-from-details", product);
    }
  },
};
</script>

<style scoped>
.product-detail-modal {
  --border-radius: 28px 28px 0 0;
}

.product-container {
  padding-bottom: 20px;
}

/* Image Styling */
.image-wrapper {
  position: relative;
  width: 100%;
  margin-top: 10px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.main-image {
  width: 100%;
  height: 300px;
  object-fit: cover;
  display: block;
}

.share-fab {
  position: absolute;
  top: 15px;
  right: 15px;
  --border-radius: 50%;
  --padding-start: 10px;
  --padding-end: 10px;
  --background: rgba(255, 255, 255, 0.9);
  --color: var(--primary-color, #8C1115);
  --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin: 0;
}

/* Info Section */
.info-section {
  margin-top: 24px;
}

.price-badge {
  color: var(--primary-color, #8C1115);
  font-size: 1.25rem;
  font-weight: 800;
  margin-bottom: 8px;
}

.product-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2d3436;
  margin: 0 0 16px 0;
  line-height: 1.2;
}

.divider {
  height: 1px;
  background: #f1f2f6;
  margin: 20px 0;
}

.section-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #b2bec3;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.product-description {
  font-size: 0.95rem;
  color: #636e72;
  line-height: 1.6;
  margin-top: 8px;
}

/* Footer Button */
.footer-action {
  padding: 16px 20px 30px 20px;
  background: white;
}

.btn-main {
  --background: var(--primary-color, #8C1115);
  --border-radius: 14px;
  --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-weight: 700;
  height: 52px;
  margin: 0;
}

ion-title {
  font-weight: 700;
  font-size: 1rem;
}
</style>